export { initializeTracesAPI } from './initialize';

export type { OTELApi, TraceContext, TraceEvent, TracesAPI } from './types';



// WEBPACK FOOTER //
// ../../../../src/api/traces/index.ts